import {Logic} from '../Type'
export class LoadingResourcesState extends Logic.Type {
    public loadedResources: any[]
}